import {_} from 'lodash';
import * as ko from "knockout";
import {IObjectData} from "../../../../index";
import {KOSubscriptionTracker} from "../../../../util/KOSubscriptionTracker";
import {ObjectTypeId} from "../../../../constants";
import {RuleMutable} from "../RuleMutable";
import {getObjectDisplayName, getRawSyncFieldValue} from "../../../../util/misc";
import {lm} from "../../../../appContext";
import {NO_DATA_MESSAGE} from "../../../../constants/Language";
import {IComboboxV2Options} from "../../../combobox/v2";
import {createApiListPromise, createBaseTextMatch} from "../../../combobox/v2-sources";
import add_departmentsHtml from './add-departments.html?raw';

export let template = add_departmentsHtml;

interface IParams {
    ruleMutable: RuleMutable
}

export class viewModel {
    private readonly ObjectTypeId = ObjectTypeId
    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private readonly departments: KnockoutObservableArray<IObjectData> = ko.observableArray(null);
    private readonly departmentComboboxOptions: IComboboxV2Options<IObjectData>

    constructor(private params: IParams) {
        this.departments(params.ruleMutable.departments() ?? []);
        this.kosub.subscribe(this.departments, departments => {
            this.params.ruleMutable.departments(departments);
        });

        // Pick-and-add: v2 clears input + leaves selected empty, then latches chrome (empty → ok).
        const labelFn = this.getObjectDisplayName
        const apiList = createApiListPromise<IObjectData>({
            api: 'searchobject',
            isSearch: true,
            params: {objecttypeid: ObjectTypeId.Department} as any,
        })
        this.departmentComboboxOptions = {
            promise: apiList.promise,
            onDispose: apiList.onDispose,
            selectionMode: 'pick',
            emptyPreparedListMessage: NO_DATA_MESSAGE,
            inputAttrs: {
                placeholder: lm.t('add department|td') ?? '',
            },
            option: {
                label: labelFn,
                match: createBaseTextMatch(labelFn),
                constrain: (o) => !this.departments().includes(o),
            },
            prepareData: {
                sort: (items) => _.sortBy(items, labelFn),
            },
            onSelect: (o) => {
                if (o != null) {
                    this.departments.push(o)
                }
            },
        }
    }

    private removeDepartment(department: IObjectData) {
        this.departments.remove(department);
    }

    private getObjectDisplayName = (department: IObjectData) => {
        const name = getObjectDisplayName(department)
        const nr = getRawSyncFieldValue('OrgUnitnr', department.syncfields) ?? ''
        if (nr && name?.includes(nr)) {
            return name
        } else {
            return `${name ?? ''} (${nr})`
        }
    }
    private getRawSyncFieldValue = getRawSyncFieldValue

    private sorted(): IObjectData[] {
        return _.sortBy(this.departments(), this.getObjectDisplayName);
    }

    dispose() {
        this.kosub.unsuscribeAll();
    }
}
